import React, { useContext } from 'react';
import styles from './style.cssmodule.css';
import ParkingsTable from '../ParkingsTable/ParkingsTable';
import ParkingsCards from '../ParkingsCards/ParkingsCards';
import NoResults from '../NoResults/NoResults';
import { ParkingsContext } from '../../contexts/ParkingsContext';
import TableFooter from '../TableFooter/TableFooter';

function Parkings() {
  const { parkings } = useContext(ParkingsContext);
  if (!parkings) return null;
  const hasParkings = parkings.length > 0;

  return (
    <div>
      <div className={styles.listWrapper}>
        <div className={styles.mobile}>
          <ParkingsCards />
        </div>
        <div className={styles.desktop}>
          <ParkingsTable />
        </div>
        {!hasParkings && <NoResults />}
      </div>
      <TableFooter />
    </div>
  );
}

export default Parkings;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Parkings/Parkings.jsx